// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Currency from "../../../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_Option from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function getFareVm(fare, currency) {
  return {
          base_fare: Currency.toCurrencyString(fare.breakup_details.base_fare, currency),
          pre_trip_fare_round_off: Belt_Option.mapWithDefault(fare.breakup_details.pre_trip_fare_round_off, "N/A", (function (v) {
                  return Currency.toCurrencyString(v, currency);
                })),
          distance_charge: Currency.toCurrencyString(fare.breakup_details.distance_charge, currency),
          time_charge: Currency.toCurrencyString(Currency.add(fare.breakup_details.waiting_charge, fare.breakup_details.travel_duration_charge), currency),
          waypoint_charge: Currency.toCurrencyString(fare.breakup_details.waypoint_charge, currency),
          toll: Currency.toCurrencyString(fare.breakup_details.toll, currency),
          vat: Belt_Option.mapWithDefault(fare.breakup_details.vat, undefined, (function (v) {
                  return Currency.toCurrencyString(v, currency);
                })),
          helper_charge: Currency.toCurrencyString(fare.breakup_details.helper_charge, currency),
          helper_labour_charges: Currency.toCurrencyString(fare.breakup_details.helper_plus_labour_charge, currency),
          porter_gold_savings: Currency.toCurrencyString(fare.breakup_details.subscription_discount, currency),
          coupon_discount: Currency.toCurrencyString(fare.breakup_details.coupon_discount, currency),
          rewards_discount: Currency.toCurrencyString(fare.breakup_details.rewards_discount, currency),
          referral_discount: Currency.toCurrencyString(fare.breakup_details.referral_discount, currency),
          pickup_extra_charge: Belt_Option.mapWithDefault(fare.breakup_details.pickup_extra_charge, "N/A", (function (v) {
                  return Currency.toCurrencyString(v, currency);
                })),
          drop_extra_charge: Belt_Option.mapWithDefault(fare.breakup_details.drop_extra_charge, "N/A", (function (v) {
                  return Currency.toCurrencyString(v, currency);
                })),
          previous_due: Currency.toCurrencyString(fare.previous_due, currency),
          courier_fee: Belt_Option.mapWithDefault(fare.breakup_details.courier_fee, undefined, (function (v) {
                  return Currency.toCurrencyString(v, currency);
                })),
          underpayment_sop_status: fare.breakup_details.underpayment_sop_status
        };
}

function getVm(order_fare, currency) {
  var customer = order_fare.fare_details.customer;
  if (customer !== undefined) {
    return getFareVm(customer, currency);
  } else {
    return getFareVm(order_fare.fare_details.estimated, currency);
  }
}

export {
  getFareVm ,
  getVm ,
  
}
/* No side effect */
